export default {"src":"/_next/static/media/icon_play_button_instamatch.e2ad29a8.svg","height":42,"width":45,"blurWidth":0,"blurHeight":0};